import React, { useEffect } from 'react';
import Page404 from './Page404';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from 'react-router-dom';
import Chat from './Chat';
import DemoSpeech from './DemoSpeechToText';
import DemoTalkingAssistant from './DemoTalkingAssistant/DemoTalkingAssistant';
import VideoAssistente from './DemoTalkingAssistant/VideoAssistente';

const RoutesSite = (url) => {
  return (
    <Routes>
      <Route path="/" element={<Chat />} />
      <Route path="/knots-chatbot" element={<Chat />} />
      <Route path="/sql-agent" element={<Chat />} />
      <Route path="/demo-speech" element={<DemoSpeech />} />
      <Route path="/brescia-musei" element={<DemoTalkingAssistant />} />
      <Route path="/video-assistente" element={<VideoAssistente />} />
      <Route path="*" element={<Page404 />} />
    </Routes>
  );
};

export default RoutesSite;
